export const enum PaginasEnum {
    JORNADA_DESENVOLVIMENTO = 'JORNADA',
    BIBLIOTECA = 'BIBLIOTECA',
    CURSOS_LIVRES = 'CURSO_LIVRE',
    TRILHAS = 'TRILHAS',
}
